export const USER_GETALL = "USER_GETALL";

export const USER_GETALL_PENDING = "USER_GETALL_PENDING";

export const USER_GETALL_SUCCESS = "USER_GETALL_SUCCESS";

export const USER_GETALL_ERROR = "USER_GETALL_ERROR";

export const USERS_GET_ROLES = "USERS_GET_ROLES";

export const USERS_GET_ROLES_PENDING = "USERS_GET_ROLES_PENDING";

export const USERS_GET_ROLES_SUCCESS = "USERS_GET_ROLES_SUCCESS";

export const USERS_GET_ROLES_ERROR = "USERS_GET_ROLES_ERROR";

export const USERS_SAVE = "USERS_SAVE";

export const USERS_SAVE_PENDING = "USERS_SAVE_PENDING";

export const USERS_SAVE_SUCCESS = "USERS_SAVE_SUCCESS";

export const USERS_SAVE_ERROR = "USERS_SAVE_ERROR";

export const USERS_CHECK_DUPLICATE_EMAIL = "USERS_CHECK_DUPLICATE_EMAIL";

export const USERS_CHECK_DUPLICATE_NAME = "USERS_CHECK_DUPLICATE_NAME";

export const USERS_CHECK_DUPLICATE_USERNAME = "USERS_CHECK_DUPLICATE_USERNAME";

export const USERS_GET = "USERS_GET";

export const USERS_GET_PENDING = "USERS_GET_PENDING";

export const USERS_GET_SUCCESS = "USERS_GET_SUCCESS";

export const USERS_GET_ERROR = "USERS_GET_ERROR";

export const USERS_GET_DEPARTMENTS = "USERS_GET_DEPARTMENTS";

export const USERS_GET_DEPARTMENTS_PENDING = "USERS_GET_DEPARTMENTS_PENDING";

export const USERS_GET_DEPARTMENTS_SUCCESS = "USERS_GET_DEPARTMENTS_SUCCESS";

export const USERS_GET_DEPARTMENTS_ERROR = "USERS_GET_DEPARTMENTS_ERROR";
